import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { useAuth } from "../context/AuthProvider";
import { authLink, authNext } from "../lib/authNavigation";
import logo from "../assets/kailospay/logo-blue.png";
import "../styles/july-design.css";
import "../styles/flow-header.css";

export default function Header({ focused = false }: { focused?: boolean }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const header = useRef<HTMLElement>(null);
  const toggle = useRef<HTMLButtonElement>(null);
  const returnPath = authNext(location.pathname + location.search + location.hash)
    ?? authNext(new URLSearchParams(location.search).get("next"));
  const loginPath = authLink("/login", returnPath);
  const account = user?.is_admin ? "/admin" : "/my";
  const accountLabel = user?.is_admin ? "관리자 페이지" : "마이페이지";
  const action = () => { setOpen(false); nav(user ? "/pay" : "/registration"); };
  useEffect(() => { setOpen(false); }, [location.key]);
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => { if (e.key === "Escape") { setOpen(false); toggle.current?.focus(); } };
    const onOutside = (e: PointerEvent) => { if (!header.current?.contains(e.target as Node)) setOpen(false); };
    document.addEventListener("keydown", onKey);
    document.addEventListener("pointerdown", onOutside);
    return () => { document.removeEventListener("keydown", onKey); document.removeEventListener("pointerdown", onOutside); };
  }, [open]);
  if (focused) return <header className="jp-header jp-flow-header">
    <div className="jp-nav-wrap">
      <Link to="/" className="jp-brand" aria-label="주류페이 홈"><img src={logo} alt="주류페이" /></Link>
      <Link to={user ? "/pay" : "/"} className="jp-flow-close" aria-label="입력 화면 닫기"><X size={20} /></Link>
    </div>
  </header>;
  return <header ref={header} className="jp-header">
    <div className="jp-nav-wrap">
      <Link to="/" className="jp-brand" aria-label="주류페이 홈"><img src={logo} alt="주류페이" /></Link>
      <nav className="jp-desktop-links" aria-label="주요 메뉴"><NavLink to="/guide">이용안내</NavLink><NavLink to="/faq">자주 묻는 질문</NavLink><NavLink to="/support">고객센터</NavLink></nav>
      <div className="jp-header-actions">
        {user ? <><Link className="jp-account" to={account}>{accountLabel}</Link><button className="jp-account" onClick={() => void logout()}>로그아웃</button></> : <Link className="jp-account" to={loginPath}>로그인</Link>}
        <button className="jp-button jp-header-pay" onClick={action}>{user ? "이용목록" : "결제등록"}<ArrowUpRight size={16} aria-hidden="true" /></button>
        <button ref={toggle} type="button" className="jp-menu-toggle" aria-label={open ? "메뉴 닫기" : "메뉴 열기"} aria-expanded={open} aria-controls="jp-mobile-menu" onClick={() => setOpen(v => !v)}>{open ? <X /> : <Menu />}</button>
      </div>
    </div>
    {open && <nav id="jp-mobile-menu" className="jp-mobile-menu" aria-label="모바일 메뉴">
      {user && <p>{user.name}님, 안녕하세요.</p>}
      <Link to="/guide">이용안내<ArrowUpRight size={16} /></Link><Link to="/faq">자주 묻는 질문<ArrowUpRight size={16} /></Link><Link to="/support">고객센터<ArrowUpRight size={16} /></Link><Link to={account}>{accountLabel}<ArrowUpRight size={16} /></Link>
      {user ? <button onClick={() => { setOpen(false); void logout(); }}>로그아웃</button> : <Link to={loginPath}>로그인<ArrowUpRight size={16} /></Link>}
    </nav>}
  </header>;
}
